var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "page-section"
  }, [this.$slots['default'] ? _c('v-container', [this.$slots['title'] ? _c('div', {
    staticClass: "tit-wrap tit-wrap--lg text-center"
  }, [this.$slots['title'] ? _c('h3', {
    staticClass: "tit tit--xxl",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._t("title")], 2) : _vm._e(), this.$slots['text'] ? _c('div', {
    staticClass: "txt txt--lg",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_vm._t("text")], 2) : _vm._e()]) : _vm._e(), this.$slots['titleLine'] ? _c('div', {
    staticClass: "tit-wrap text-center"
  }, [this.$slots['titleLine'] ? _c('h3', {
    staticClass: "tit tit--xxl",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._t("titleLine")], 2) : _vm._e()]) : _vm._e(), this.$slots['titleLine'] ? _c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('v-divider', {
    staticClass: "h-100px h-md-200px grey darken-4",
    attrs: {
      "vertical": "",
      "data-aos": "fade",
      "data-aos-delay": "100"
    }
  })], 1) : _vm._e(), _vm._t("default")], 2) : _vm._e(), this.$slots['pageSectionImmersive'] ? _vm._t("pageSectionImmersive") : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }